/* GUL Flowers — motion engine v2 (reveals, stagger, parallax, cursor, countdown) */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    window.location.search.indexOf('gul-static') !== -1;
  if (reduced) document.documentElement.classList.add('gul-no-motion');

  function bahrainNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Bahrain' })); }

  /* ---------- same-day delivery countdown (runs even with reduced motion) ---------- */
  function tickCountdown() {
    document.querySelectorAll('.gul-countdown').forEach(function (el) {
      el.textContent = 'Order before 2 PM for same-day delivery, between 2–7 PM.';
    });
  }
  tickCountdown();


  /* ---------- gift flow: card message + delivery date on PDP (all users) ---------- */
  function initGiftFlow() {
    /* main product form only — never the quick-add forms inside product cards */
    var form = null;
    Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"][data-type="add-to-cart-form"]')).some(function (f) {
      if (f.closest('.card, .card-wrapper, .quick-add, quick-add-modal, cart-drawer, .cart-drawer')) return false;
      if (!f.closest('product-info, .product__info-wrapper, .product__info-container, .product')) return false;
      form = f; return true;
    });
    if (!form || document.querySelector('.gul-gift')) return;
    var formId = form.getAttribute('id');
    if (!formId) return;
    var host = form.closest('product-form') || form;
    var now = bahrainNow();
    var min = new Date(now);
    if (now.getHours() >= 14) min.setDate(min.getDate() + 1);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var minStr = min.getFullYear() + '-' + pad(min.getMonth() + 1) + '-' + pad(min.getDate());

    var wrap = document.createElement('div');
    wrap.className = 'gul-gift';
    wrap.innerHTML =
      '<p class="gul-gift__title">Make it a gift</p>' +
      '<label class="gul-gift__label" for="GulCardMessage">Card message <span>complimentary</span></label>' +
      '<textarea id="GulCardMessage" class="gul-gift__input gul-gift__textarea" rows="2" maxlength="200" ' +
        'placeholder="Written by hand on a GUL card\u2026 don\u2019t forget to sign it \u2014 Love, Sara \u2740" name="properties[Card message]" form="' + formId + '"></textarea>' +
      '<span class="gul-gift__count" aria-hidden="true">0/200</span>' +
      '<div class="gul-card-preview" hidden aria-hidden="true">' +
        '<div class="gul-card"><span class="gul-card__mark">GUL<small>flowers boutique</small></span>' +
        '<p class="gul-card__text"></p></div>' +
        '<span class="gul-card-preview__caption">Your card, written by hand</span>' +
      '</div>' +
      '<label class="gul-gift__label" for="GulDeliveryDate">Delivery date <span>optional — pick any future date</span></label>' +
      '<input id="GulDeliveryDate" class="gul-gift__input" type="date" min="' + minStr + '" ' +
        'name="properties[Delivery date]" form="' + formId + '">' +
      '<p class="gul-gift__hint"><span class="gul-countdown">Order before 2 PM for same-day delivery, between 2–7 PM.</span></p>';
    host.parentNode.insertBefore(wrap, host);
    var ta = wrap.querySelector('#GulCardMessage');
    var count = wrap.querySelector('.gul-gift__count');
    var preview = wrap.querySelector('.gul-card-preview');
    var cardText = wrap.querySelector('.gul-card__text');
    if (ta && count) {
      ta.addEventListener('input', function () {
        count.textContent = ta.value.length + '/200';
        count.classList.toggle('is-max', ta.value.length >= 200);
        var v = ta.value.trim();
        if (preview && cardText) {
          cardText.textContent = v;
          preview.hidden = !v;
          if (v) setTimeout(function () { preview.classList.add('is-in'); }, 20);
          else preview.classList.remove('is-in');
        }
      });
    }
    tickCountdown();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftFlow);
  } else {
    initGiftFlow();
  }


  /* ---------- recently viewed (PDP, localStorage) ---------- */
  function initRecentlyViewed() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/);
    if (!m) return;
    var handle = m[1], KEY = 'gul-rv', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var others = list.filter(function (h) { return h !== handle; });
    try { localStorage.setItem(KEY, JSON.stringify([handle].concat(others).slice(0, 8))); } catch (e) {}
    var show = others.slice(0, 4);
    if (show.length < 2) return;
    var main = document.querySelector('main');
    if (!main) return;
    Promise.all(show.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      if (ps.length < 2) return;
      var sec = document.createElement('section');
      sec.className = 'gul-section gul-rv';
      var grid = '';
      ps.forEach(function (p) {
        var img = (p.featured_image || '') + ((p.featured_image || '').indexOf('?') > -1 ? '&' : '?') + 'width=500';
        grid += '<a class="gul-finder__card" href="/products/' + p.handle + '">' +
          '<span class="gul-finder__card-media"><img loading="lazy" alt="" src="' + img + '"></span>' +
          '<span class="gul-finder__card-title"></span>' +
          '<span class="gul-finder__card-price">' + (p.price / 100).toFixed(3) + ' BHD</span></a>';
      });
      sec.innerHTML = '<div class="gul-container">' +
        '<div class="gul-section__head"><p class="gul-eyebrow">Still deciding?</p>' +
        '<h2 class="gul-section__title">Recently viewed</h2></div>' +
        '<div class="gul-rv__grid">' + grid + '</div></div>';
      main.appendChild(sec);
      var titles = sec.querySelectorAll('.gul-finder__card-title');
      ps.forEach(function (p, i) { if (titles[i]) titles[i].textContent = p.title; });
    });
  }
  /* hide media slider chrome on single-image products */
  function initSingleMedia() {
    document.querySelectorAll('.product__media-wrapper').forEach(function (w) {
      var items = w.querySelectorAll('.product__media-list .product__media-item');
      if (items.length <= 1) {
        w.querySelectorAll('.slider-buttons').forEach(function (b) { b.style.display = 'none'; });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSingleMedia);
  } else {
    initSingleMedia();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  } else {
    initRecentlyViewed();
  }


  /* ---------- mobile buy bar (PDP, <750px): mirrors the real submit button ---------- */
  function initBuyBar() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var real = document.querySelector('product-form .product-form__submit');
    var buttons = document.querySelector('product-form .product-form__buttons');
    if (!real || !buttons || document.querySelector('.gul-buybar')) return;
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var bar = document.createElement('div');
    bar.className = 'gul-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="gul-buybar__info"><span class="gul-buybar__title"></span><span class="gul-buybar__price"></span></div>' +
      '<button type="button" class="gul-buybar__btn"></button>';
    bar.querySelector('.gul-buybar__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var btn = bar.querySelector('.gul-buybar__btn');
    var priceOut = bar.querySelector('.gul-buybar__price');
    var sync = function () {
      var p = document.querySelector('.price__container .price-item--regular') || document.querySelector('.price-item--regular');
      priceOut.textContent = p ? p.textContent.trim() : '';
      var disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
      btn.disabled = disabled;
      var label = real.querySelector('span');
      btn.textContent = real.classList.contains('loading') ? 'Adding…' :
        (label ? label.textContent.trim() : 'Add to cart');
    };
    sync();
    document.body.appendChild(bar);
    btn.addEventListener('click', function () { real.click(); });
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(real, { attributes: true, childList: true, subtree: true, characterData: true });
      var priceHost = document.querySelector('[id^="price-"]');
      if (priceHost) new MutationObserver(sync).observe(priceHost, { childList: true, subtree: true, characterData: true });
    }
    var setShown = function (shown) {
      bar.classList.toggle('is-in', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
    };
    var outOfView = function () {
      var r = buttons.getBoundingClientRect();
      return r.bottom < 0 || r.top > window.innerHeight - 80;
    };
    setShown(outOfView());
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setShown(!entries[0].isIntersecting);
      }, { threshold: 0.2 }).observe(buttons);
    } else {
      window.addEventListener('scroll', function () { setShown(outOfView()); }, { passive: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyBar);
  } else {
    initBuyBar();
  }

  /* WhatsApp helper tooltip, once per session */
  function initWaTip() {
    var wa = document.querySelector('.gul-whatsapp');
    if (!wa) return;
    try { if (sessionStorage.getItem('gulWaTip')) return; } catch (e) {}
    setTimeout(function () {
      try { sessionStorage.setItem('gulWaTip', '1'); } catch (e) {}
      var tip = document.createElement('div');
      tip.className = 'gul-wa-tip';
      tip.textContent = 'Need help choosing? Chat with us \u2740';
      document.body.appendChild(tip);
      requestAnimationFrame(function () { tip.classList.add('is-in'); });
      var hide = function () { tip.classList.remove('is-in'); setTimeout(function () { tip.remove(); }, 400); };
      setTimeout(hide, 9000);
      tip.addEventListener('click', function () { hide(); wa.click(); });
    }, 18000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWaTip);
  } else {
    initWaTip();
  }


})();
